import { useSavedChartsStore } from '@/stores/savedChartsStore';
import { SimpleFrontendChartStyle } from '@/interfaces/chartStyle';

export function getSavedChartStyleFromCache(recid: number): SimpleFrontendChartStyle | null {
  const savedChartsStore = useSavedChartsStore();

  return savedChartsStore.chartStyles.find(cs => cs.recid === recid) ?? null;
}
